
interface ProductCardProps {
  product: {
    id: number;
    name: string;
    price: number;
    originalPrice?: number;
    rating: number;
    image: string;
  };
  onAddToCart: (product: any) => void;
  onClick?: () => void;
}

export default function ProductCard({ product, onAddToCart, onClick }: ProductCardProps) {
  const handleCardClick = (e: React.MouseEvent) => {
    // منع التنقل عند الضغط على زر الإضافة للسلة
    if ((e.target as HTMLElement).closest('button')) {
      return;
    }
    onClick?.();
  };

  return (
    <div 
      className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 cursor-pointer"
      onClick={handleCardClick}
    >
      <div className="relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-32 object-cover object-top"
        />
        {product.originalPrice && (
          <div className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
            خصم
          </div>
        )}
      </div>
      
      <div className="p-3">
        <h3 className="font-semibold text-[#333333] text-sm mb-2 line-clamp-2 text-right" dir="rtl">
          {product.name}
        </h3>
        
        <div className="flex items-center justify-between mb-2" dir="rtl">
          <div className="flex items-center">
            {[...Array(5)].map((_, i) => (
              <i
                key={i}
                className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-xs ${
                  i < product.rating ? 'text-[#D4AF37]' : 'text-gray-300'
                }`}
              />
            ))}
          </div>
          <span className="text-xs text-[#777777]">({product.rating})</span>
        </div>
        
        <div className="flex items-center justify-between mb-3" dir="rtl">
          <div className="flex items-center space-x-2">
            <span className="font-bold text-[#4B2E05] text-sm">
              {product.price} ر.س
            </span>
            {product.originalPrice && (
              <span className="text-xs text-[#777777] line-through">
                {product.originalPrice} ر.س
              </span>
            )}
          </div>
        </div>
        
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddToCart(product);
          }}
          className="w-full bg-[#D4AF37] text-white py-2 rounded-lg text-sm font-medium hover:bg-[#B8941F] transition-colors duration-200"
        >
          أضف إلى السلة
        </button>
      </div>
    </div>
  );
}